import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  seeResults: ({ search }: { search: string }) => ({
    key: 'SearchTopicsPage-seeResults',
    parameters: { search },
    defaultValue: 'Ver resultados para: "{search}"',
  }),
})
